module.exports = __webpack_public_path__ + "img/avatar.b84cef86.svg";